import { useMemo } from 'react';
import {
  ACTIONS,
  Joyride,
  STATUS,
  type EventData,
  type Step,
} from 'react-joyride';
import { useI18nContext } from '@/i18n/i18n-react';
import { METRICS_TOUR_SELECTORS } from '@/constants/metrics-tour-target-ids';
import { MetricsPageTourTooltip } from '@/components/metrics-page-tour-tooltip';
import { useLocalSettings } from './use-local-settings';

export function MetricsPageTour() {
  const { LL } = useI18nContext();
  const { localSettings, setLocalSettings } = useLocalSettings();

  const steps = useMemo<Step[]>(
    () => [
      {
        target: METRICS_TOUR_SELECTORS.filters,
        content: LL.metricsPage.tour.filtersStep(),
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: METRICS_TOUR_SELECTORS.firstMetricHelpIcon,
        content: LL.metricsPage.tour.helpIconStep(),
        placement: 'bottom',
        disableBeacon: true,
      },
    ],
    [LL]
  );

  const markCompleted = () => {
    setLocalSettings({
      ...localSettings,
      metricsPageTourCompleted: true,
    });
  };

  const handleEvent = (data: EventData) => {
    const { action, status } = data;
    const finished =
      status === STATUS.FINISHED ||
      status === STATUS.SKIPPED ||
      action === ACTIONS.CLOSE;

    if (finished) {
      markCompleted();
    }
  };

  return (
    <Joyride
      run={!localSettings.metricsPageTourCompleted}
      steps={steps}
      onEvent={handleEvent}
      continuous
      options={{
        arrowColor: '#262626',
        skipBeacon: true,
        hideOverlay: true,
        skipScroll: true,
      }}
      locale={{
        back: LL.metricsPage.tour.controls.back(),
        close: LL.metricsPage.tour.controls.close(),
        last: LL.metricsPage.tour.controls.done(),
        next: LL.metricsPage.tour.controls.next(),
        skip: LL.metricsPage.tour.controls.skip(),
      }}
      tooltipComponent={MetricsPageTourTooltip}
    />
  );
}
